// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export async function servipagOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'servipag',
    payment_type_code: 'servipag',
  };
}
